import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleReactionThunk } from "../../../Slices/chatSlice";

const ReactionBadges = ({ reactions, messageId, conversationId }) => {
  const dispatch = useDispatch();
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);

  if (!reactions || reactions.length === 0) return null;

  const userName = loginUser?.firstname
    ? `${loginUser.firstname} ${loginUser.lastname || ""}`.trim()
    : "User";

  // Group reactions by emoji
  const grouped = {};
  reactions.forEach((r) => {
    if (!grouped[r.emoji]) grouped[r.emoji] = [];
    grouped[r.emoji].push(r);
  });

  const handleToggle = (emoji) => {
    dispatch(toggleReactionThunk({
      messageId,
      conversationId,
      emoji,
      userId: loginUser?.id,
      userName,
    }));
  };

  return (
    <div className="reaction-badges">
      {Object.entries(grouped).map(([emoji, users]) => {
        const isOwnReaction = users.some((u) => u.userId === loginUser?.id);
        return (
          <button
            key={emoji}
            className={`reaction-badge ${isOwnReaction ? "reaction-badge--own" : ""}`}
            onClick={() => handleToggle(emoji)}
            title={users.map((u) => u.userName).join(", ")}
            type="button"
          >
            <span className="reaction-badge__emoji">{emoji}</span>
            <span className="reaction-badge__count">{users.length}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ReactionBadges;
